import styled, { css } from 'styled-components'
import {
  Modal as ModalDefault,
  ModalHeader as ModalHeaderDefault,
  ModalBody as ModalBodyDefault,
  ModalFooter as ModalFooterDefault,
} from 'reactstrap'

import theme from 'vars/theme'
import SingleForm from 'components/SingleForm'
import { Label } from 'components/SelectOptions/CreatableSelectLoading'

export const MessageModal = styled(ModalDefault)`
  min-width: 800px;

  .modal-content {
    padding: 5px;
  }
`

export const ModalHeader = styled(ModalHeaderDefault)`
  padding: 0;

  .modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px;
    outline: none;
    background: white;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }

  h5 {
    margin: 0;
    font-weight: bold;
  }
`

export const ModalContent = styled.div`
  border-radius: 10px;
  background: ${theme.graySoft1};
`

export const ModalBody = styled(ModalBodyDefault)`
  display: flex;
  flex-direction: column;
  margin: 0;
`

export const ModalFooter = styled(ModalFooterDefault)`
  button {
    min-width: 100px;
  }

  button:nth-child(2) {
    color: ${theme.blueMedium5};
    background-color: white;
    border: 1px solid ${theme.blueMedium5};
  }
`

export const WrapperListItem = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 15px 0;
  margin-bottom: 10px;
`

export const FilterItem = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  font-size: 12px;
  margin-right: 10px;
`

export const RadioFilter = styled.input`
  margin-right: 5px;
  width: 17px;
  height: 17px;
`

export const CustomInputDate = styled(SingleForm)`
  width: inherit;
`

export const ButtonWrapper = styled.div`
  display: flex;
  margin-right: 5px;
`

export const ButtonImport = styled.button<{ isSelected?: boolean }>`
  margin-right: 2px;
  border-radius: 0;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border: 1px solid ${theme.brownMedium1};
  color: ${theme.brownMedium1};
  background-color: white;
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;

  &:hover {
    border: 1px solid ${theme.blueMedium5};
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: white;
      background-color: ${theme.brownMedium1};
    `}

  @supports (-webkit-touch-callout: none) {
    font-size: 14px;
    margin-right: 3px;
    padding-left: 4px;
    padding-right: 4px;
  }
`

export const ButtonExport = styled.button<{ isSelected?: boolean }>`
  border-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid ${theme.brownMedium1};
  color: ${theme.brownMedium1};
  background-color: white;
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;

  &:hover {
    border: 1px solid ${theme.blueMedium5};
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: white;
      background-color: ${theme.brownMedium1};
    `}

  @supports (-webkit-touch-callout: none) {
    font-size: 14px;
    padding-left: 4px;
    padding-right: 4px;
  }
`

export const ButtonAll = styled.button`
  outline: none;
  padding: 3px 6px;
  font-size: 13px;
  border-radius: 5px;
  border: 1px solid ${theme.brownMedium1};
  color: white;
  background-color: ${theme.brownMedium1};
`

export const LabelFilter = styled(Label)`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0px;
`

export const FilterSearchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  background: ${theme.graySoft1};
  padding: 8px 8px 8px 4px;
`

export const TextCheckinLabel = styled.span`
  font-size: 16px;
`

export const NumberPendingStyled = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  min-width: 20px;
  font-weight: 600;
  height: 20px;
`

export const WrapperDetailFilter = styled.div`
  min-height: 120px;
  max-height: 120px;
  font-size: 14px;
  background: #dddddd;
  color: black;
  border-radius: 5px;
  padding: 5px 10px;
  transition: max-height 0.5s ease-out;
  overflow: auto;
  box-shadow:
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  margin: 5px;
`

export const StyledUl = styled.ul`
  font-size: 12px;
  padding-left: 20px;
  margin-bottom: 0px;
`

export const StyledStrong = styled.strong`
  font-weight: 600;
  font-size: 13px;
`

export const StyledLi = styled.li`
  font-weight: 400;
`

export const StyledButton = styled.button`
  color: ${theme.blueMedium5};
  border: 1px solid ${theme.blueMedium5};
  background-color: white;
  border-radius: 5px;
`

export const StyleTitle = styled.span`
  font-weight: 700;
  min-width: 100px;
`
